// src/components/About.js
import React, { useState} from 'react';
import './About.css';
import { uonLogo, srcsLogo, karnivalLogo, wollatonLogo, compsocLogo, uonsuLogo, dotIcon, prathuIcon } from '../assets';
import { BioSection, SplashCursor } from '../components';

const About = () => {
  const [splashState, setSplashState] = useState('hidden'); // 'hidden', 'visible', 'fading'

  const handleDoubleClick = () => {
    setSplashState('visible');
    
    setTimeout(() => {
      setSplashState('fading');
      setTimeout(() => {
        setSplashState('hidden');
      }, 500);
    }, 14500);
  };

  const educationItems = [
    {
      imgSrc: uonLogo,
      title: 'B.Sc Computer Science with AI',
      institution: 'University of Nottingham',
      date: "Sep '22 — Jun '26",
      hoverText: 'Achieved a 1st overall',
    },
    {
      imgSrc: srcsLogo,
      title: 'Higher Secondary',
      institution: 'Shri Ram Centennial School',
      date: "May '21",
      hoverText: 'Completed high school education',
    },
  ];

  const volunteerItems = [
    {
      imgSrc: karnivalLogo,
      title: 'Treasurer',
      institution: 'Nottingham Karnival',
      date: "Sep '24 — Present",
      hoverText: 'Largest Student Led Fundraising Group in Europe',
    },
    {
      imgSrc: wollatonLogo,
      title: 'Scorer',
      institution: 'Wollaton Cricket Club',
      date: "Jun '24 — Sep '24",
      hoverText: 'Scoring Games on Weekends for Wollaton 1st Team',
    },
    {
      imgSrc: compsocLogo,
      title: 'Welfare Head',
      institution: 'UoN CompSoc',
      date: "Sep '23 — Sep '24",
      hoverText: 'Confidential and approachable point of contact for society members',
    },
    {
      imgSrc: uonLogo,
      title: 'Student Mentor',
      institution: 'University of Nottingham',
      date: "Sep '23 — Sep '24",
      hoverText: 'Assisted mentees in understanding the Computer Science curriculum',
    },
    {
      imgSrc: uonsuLogo,
      title: 'Global Buddies Mentor',
      institution: 'UoN Students Union',
      date: "Sep '23 — Sep '24",
      hoverText: 'Assisted new students in acclimating to university life',
    },
  ];

  return (
    <section id="about" className="about">
      <div className="titletext">
        <l1>GET TO</l1>
        <l2>
          KNOW <l2b>ME</l2b>
          <img 
            src={prathuIcon} 
            className="pratimg" 
            alt="prathuimg"
            onClick={handleDoubleClick}
          ></img>
        </l2>
        <img src={dotIcon} className="dot" alt="dotimg"></img>
      </div>
      {splashState !== 'hidden' && (
        <SplashCursor className={splashState === 'fading' ? 'fade-out' : ''} />
      )}
      <p className="bio">
        {' '}
        BIO
        <span className="bio-text">
          My name is Prathu, and I am a Software Engineer. I do fullstack development and love building interactive user
          experiences. I have a passion for Machine Learning and am actively involved in the AI world. I believe as
          developers we hold great power to create and change the world.
        </span>
      </p>

      <div className="divider"></div>

      <BioSection title="EDUCATION" items={educationItems} />

      <div className="divider"></div>

      <BioSection title="VOLUNTEER" items={volunteerItems} />

      <div className="divider-end"></div>
    </section>
  );
};

export default About;